import { breakpoints, Button } from '@gassan-ui'
import { motion, MotionProps } from 'framer-motion'
import React, { FC } from 'react'
import styled from 'styled-components'
const Container = styled(motion.footer)`
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #fff;
  z-index: ${p => p.theme.zIndices.mobileFilters.confirmButton};
  padding-bottom: env(safe-area-inset-bottom);
  @media screen and (min-width: ${breakpoints.small}) {
    padding: 0.75rem 2rem;
  }
`

type Props = MotionProps & {
  onClickConfirm: () => void
}

const Footer: FC<Props> = ({ onClickConfirm, children }) => {
  return (
    <Container initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <Button minWidth="100%" onClick={onClickConfirm} variant="dark">
        {children}
      </Button>
    </Container>
  )
}

export default Footer
